import request from '../../../axios';

const getLikedStores = async () => {
  const {data}: {data: Array<ILikedStores>} = await request.get(
    '/api/v2/store/liked-stores-list',
  );
  return data;
};

export default getLikedStores;
